import { render, staticRenderFns } from "./NewComboboxShowcase.vue?vue&type=template&id=e269d484&scoped=true&"
import script from "./NewComboboxShowcase.vue?vue&type=script&lang=js&"
export * from "./NewComboboxShowcase.vue?vue&type=script&lang=js&"
import style0 from "./NewComboboxShowcase.vue?vue&type=style&index=0&id=e269d484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e269d484",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VLayout,VRow,VTooltip})
